<div class="list-page kapea page-container">
  <div class="form-controls-wrapper">
    <form novalidate class="ylaosan-kontrollit">
      <table>
        <tr>
          <td>
            <mat-form-field class="tiimi-select">
              <mat-label>Rajaa tiimin mukaan</mat-label>
              <mat-select [formField]="lomake.tiimi">
                <mat-option [value]="''"> Valitse tiimi </mat-option>
                <mat-option [value]="null"> Kaikki </mat-option>
                @for (tiimi of tiimitObservable | async; track tiimi) {
                  <mat-option [value]="tiimi.avain">
                    {{ tiimi.nimi }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </td>

          <td>
            <mat-form-field class="tagi-select">
              <mat-label>Rajaa tagin mukaan</mat-label>
              <mat-select [formField]="lomake.tagi">
                <mat-option [value]="null"> Kaikki </mat-option>
                @for (tagi of kaikkiTagitObservable | async; track tagi.avain) {
                  <mat-option [value]="tagi.avain">
                    {{ tagi.nimi }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </td>

          <td>
            <mat-form-field class="kuukausi-input">
              <mat-label>Kuukausi</mat-label>
              <input matInput [matDatepicker]="dp1" [formField]="lomake.kuukausi" />
              <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
              <mat-datepicker #dp1 startView="year" (monthSelected)="chosenMonthHandler($event, dp1)" panelClass="kuukausi-valitsin"></mat-datepicker>
            </mat-form-field>
          </td>
        </tr>
      </table>
    </form>
  </div>

  <mat-card class="taulukko-card mat-elevation-z12 tilastot-card">
    <div>
      <mat-card-header>
        <mat-card-title>Myyntiyhteenveto</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="taulukko-wrapper">
          <table class="mtable tiimarit-table" [class.hidden]="myyntiyhteenvetoTableLataa()">
            @for (rivi of myyntiyhteenvetoObservable | async; track rivi; let i = $index) {
              <tr [class.bold-row]="rivi.bold">
                <td>{{ rivi.nimi }}</td>
                @for (td of rivi.cols; track td) {
                  <td [class.clickable]="!rivi.bold" [class.selected-cell]="myyntiyhteenvetoTila.valittuSolu === td" (click)="avaaSolunTiedotMyyntiyhteenveto(td)">
                    {{ td.arvo }}
                  </td>
                }
              </tr>
              @if (myyntiyhteenvetoTila.valittuSolu && rivi.cols[0]?.kirjanpitajaAvain === myyntiyhteenvetoTila.valittuSolu.kirjanpitajaAvain) {
                <tr class="solu-lahteet-row">
                  <td colspan="11">
                    <div class="solu-lahteet">
                      <h4>
                        {{ rivi.nimi }}
                      </h4>
                      @if (myyntiyhteenvetoTila.lataaLahteet) {
                        <div class="spinner-center">
                          <mat-spinner diameter="30"></mat-spinner>
                        </div>
                      }
                      @if (myyntiyhteenvetoTila.lahteetEiTasmaa) {
                        <div class="warning-box">
                          <strong>Summat eivät täsmää, päivitä sivu uudelleen</strong>
                        </div>
                      }
                      @if (!myyntiyhteenvetoTila.lataaLahteet && myyntiyhteenvetoTila.lahteet && myyntiyhteenvetoTila.lahteet.length) {
                        <table class="lahteet-table">
                          @for (lahde of myyntiyhteenvetoTila.lahteet; track lahde) {
                            <tr>
                              <td>
                                <a [href]="`/asiakkaat/${lahde.av}/laskutus/katsele/${lahde.j || lahde.a}/${lahde.a}`" target="_blank">
                                  {{ lahde.n }}
                                </a>
                              </td>
                              <td>
                                <a [href]="`/asiakkaat/${lahde.av}/asiakastiedot`" target="_blank">
                                  {{ lahde.asiakasNimi }}
                                </a>
                              </td>
                              <td class="lahde-summa">{{ lahde.s | ldecimal: 2 | async }} €</td>
                            </tr>
                          }
                          <tr class="yhteensa-rivi">
                            <td colspan="2" class="yhteensa-teksti">Yhteensä ({{ myyntiyhteenvetoTila.lahteet.length }} kpl)</td>
                            <td class="lahde-summa">{{ myyntiyhteenvetoTila.lahteetYhteissumma | ldecimal: 2 | async }} €</td>
                          </tr>
                        </table>
                      }
                      @if (!myyntiyhteenvetoTila.lataaLahteet && (!myyntiyhteenvetoTila.lahteet || myyntiyhteenvetoTila.lahteet.length === 0)) {
                        <div class="no-items-text">Ei lähteitä</div>
                      }
                    </div>
                  </td>
                </tr>
              }
            }
          </table>
        </div>
        @if (myyntiyhteenvetoTableLataa()) {
          <div class="spinner-center">
            <mat-spinner></mat-spinner>
          </div>
        }
      </mat-card-content>
      <div class="info-text-wrapper">
        <p class="gray-text">Tiimin perusteella haettaessa kirjanpitäjien lista määräytyy laskujen omistajuuden mukaan - listaan tulevat vain ne kirjanpitäjät, joilla on tiimin laskuja kyseisellä ajanjaksolla. Summat ovat taulukossa ilman hyvityksiä ja hyvitystuotteita. <a href="https://app.tettra.co/teams/lemontree/pages/tilastot-tiimarit" target="_blank" class="taulukko-linkki">Lue lisää</a></p>
      </div>
    </div>
  </mat-card>

  <mat-card class="taulukko-card mat-elevation-z12 tilastot-card">
    <div>
      <mat-card-header>
        <mat-card-title>Jatkuvan laskutuksen kehitys</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="taulukko-wrapper">
          <table class="mtable tiimarit-table" [class.hidden]="jatkuvanLaskutuksenKehitysTableLataa()">
            @for (rivi of jatkuvanLaskutuksenKehitysObservable | async; track rivi; let i = $index) {
              <tr [class.bold-row]="rivi.bold">
                <td>{{ rivi.nimi }}</td>
                @for (td of rivi.cols; track td) {
                  <td [class.clickable]="td.kenttaJatkuvaLaskutus" [class.selected-cell]="jatkuvanLaskutuksenKehitysTila.valittuSolu === td" (click)="avaaSolunTiedotJatkuvaLaskutus(td)">
                    {{ td.arvo }}
                  </td>
                }
              </tr>
              @if (jatkuvanLaskutuksenKehitysTila.valittuSolu && rivi.cols[0]?.kirjanpitajaAvain === jatkuvanLaskutuksenKehitysTila.valittuSolu.kirjanpitajaAvain) {
                <tr class="solu-lahteet-row">
                  <td [attr.colspan]="rivi.cols.length + 1">
                    <div class="solu-lahteet">
                      <h4>
                        {{ rivi.nimi }}
                      </h4>
                      @if (jatkuvanLaskutuksenKehitysTila.lataaLahteet) {
                        <div class="spinner-center">
                          <mat-spinner diameter="30"></mat-spinner>
                        </div>
                      }
                      @if (jatkuvanLaskutuksenKehitysTila.lahteetEiTasmaa) {
                        <div class="warning-box">
                          <strong>Summat eivät täsmää, päivitä sivu uudelleen</strong>
                        </div>
                      }
                      @if (!jatkuvanLaskutuksenKehitysTila.lataaLahteet && jatkuvanLaskutuksenKehitysTila.lahteet && jatkuvanLaskutuksenKehitysTila.lahteet.length) {
                        <table class="lahteet-table">
                          @for (lahde of jatkuvanLaskutuksenKehitysTila.lahteet; track lahde) {
                            <tr>
                              <td>
                                <a [href]="`/asiakkaat/${lahde.asiakasAvain}/laskutus`" target="_blank">
                                  {{ lahde.nimi }}
                                </a>
                              </td>
                              <td class="lahde-summa">{{ lahde.summa | ldecimal: 2 | async }} €</td>
                            </tr>
                          }
                          <tr class="yhteensa-rivi">
                            <td>Yhteensä ({{ jatkuvanLaskutuksenKehitysTila.lahteet.length }} kpl)</td>
                            <td class="lahde-summa">{{ jatkuvanLaskutuksenKehitysTila.lahteetYhteissumma | ldecimal: 2 | async }} €</td>
                          </tr>
                        </table>
                      }
                      @if (!jatkuvanLaskutuksenKehitysTila.lataaLahteet && (!jatkuvanLaskutuksenKehitysTila.lahteet || jatkuvanLaskutuksenKehitysTila.lahteet.length === 0)) {
                        <div class="no-items-text">Ei lähteitä</div>
                      }
                    </div>
                  </td>
                </tr>
              }
            }
          </table>
        </div>
        @if (jatkuvanLaskutuksenKehitysTableLataa()) {
          <div class="spinner-center">
            <mat-spinner></mat-spinner>
          </div>
        }
      </mat-card-content>
      <div class="info-text-wrapper">
        <p class="gray-text"><a href="https://app.tettra.co/teams/lemontree/pages/tilastot-tiimarit" target="_blank" class="taulukko-linkki">Lue lisää</a></p>
      </div>
    </div>
  </mat-card>

  <mat-card class="taulukko-card mat-elevation-z12 tilastot-card">
    <div>
      <mat-card-header>
        <mat-card-title>Tilastot</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div class="taulukko-wrapper">
          <table class="mtable tiimarit-table" [class.hidden]="tilastotTableLataa()">
            @for (rivi of tilastotObservable | async; track rivi) {
              <tr [class.bold-row]="rivi.bold">
                <td>{{ rivi.nimi }}</td>
                @for (td of rivi.cols; track td) {
                  <td [class.clickable]="!rivi.bold && td.kenttaTilastot" [class.selected-cell]="tilastotTila.valittuSolu === td" (click)="avaaSolunTiedotTilastot(td)">
                    {{ td.arvo }}
                  </td>
                }
              </tr>
              @if (tilastotTila.valittuSolu && rivi.cols[0]?.kirjanpitajaAvain === tilastotTila.valittuSolu.kirjanpitajaAvain) {
                <tr class="solu-lahteet-row">
                  <td colspan="7">
                    <div class="solu-lahteet">
                      <h4>
                        {{ rivi.nimi }}
                      </h4>
                      @if (tilastotTila.lataaLahteet) {
                        <div class="spinner-center">
                          <mat-spinner diameter="30"></mat-spinner>
                        </div>
                      }
                      @if (tilastotTila.lahteetEiTasmaa) {
                        <div class="warning-box">
                          <strong>Summat eivät täsmää, päivitä sivu uudelleen</strong>
                        </div>
                      }
                      @if (!tilastotTila.lataaLahteet && tilastotTila.lahteet && tilastotTila.lahteet.length) {
                        <table class="lahteet-table">
                          @for (lahde of tilastotTila.lahteet; track lahde) {
                            <tr>
                              <td>
                                <a [href]="`/asiakkaat/${lahde.av}/sopimukset`" target="_blank">
                                  {{ lahde.asiakasNimi }}
                                </a>
                              </td>
                              <td class="lahde-summa">{{ lahde.summa | ldecimal: 2 | async }} €</td>
                            </tr>
                          }
                          <tr class="yhteensa-rivi">
                            <td>Yhteensä ({{ tilastotTila.lahteet.length }} kpl)</td>
                            <td class="lahde-summa">{{ tilastotTila.lahteetYhteissumma | ldecimal: 2 | async }} €</td>
                          </tr>
                        </table>
                      }
                      @if (!tilastotTila.lataaLahteet && (!tilastotTila.lahteet || tilastotTila.lahteet.length === 0)) {
                        <div class="no-items-text">Ei lähteitä</div>
                      }
                    </div>
                  </td>
                </tr>
              }
            }
          </table>
        </div>
        @if (tilastotTableLataa()) {
          <div class="spinner-center">
            <mat-spinner></mat-spinner>
          </div>
        }
      </mat-card-content>
      <div class="info-text-wrapper">
        <p class="gray-text">
          Tilastot taulukossa seurataan palvelupakettien määrää kirjanpitäjittäin. Laskutussummat ja keskiveloitus lasketaan asiakkaiden hinnastoista. Vastuukirjanpitäjä ja palvelupaketti määräytyvät kuukauden ensimmäisen päivän mukaan kyseiselle kuukaudelle. <a href="https://app.tettra.co/teams/lemontree/pages/tilastot-tiimarit" target="_blank" class="taulukko-linkki">Lue lisää</a>
        </p>
      </div>
    </div>
  </mat-card>
</div>
